import Icon from '../components/Icon.vue'

Icon.register({
  'shield-alt': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M466.5 83.7c17.8 7.4 29.5 24.9 29.5 44.3 0 221.3-135.9 344.6-221.6 380.3-11.8 4.9-25.1 4.9-36.9 0-107-44.6-221.5-181.8-221.5-380.3 0-19.4 11.7-36.9 29.6-44.3l192-80c4.9-2 13.2-3.7 18.5-3.7 5.3 0 13.6 1.6 18.5 3.7zM256.1 446.3c93.7-46.6 172.5-156.3 175.8-307.7l-175.9-73.3z'
      }
    ]
  }
})
